import React from 'react';
import { motion } from 'framer-motion';
function PawPrint({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 512 512" className={className} fill="currentColor" aria-hidden="true" data-id="element-143">
      <path d="M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5.3-86.2 32.6-96.8 70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7.9 78.6 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s53.9-47.3 78.5-33.3 29.1 51.7 10.2 84.1-53.9 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5 46.9 53.9 32.6 96.8-52.1 69.1-84.4 58.5z" data-id="element-144" />
    </svg>;
}
export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative overflow-hidden bg-navy text-white pt-5 pb-8 px-6" data-id="element-145">
      {/* Decorative paw prints */}
      <PawPrint className="pointer-events-none absolute -top-6 -left-8 w-32 h-32 text-teal-bright/10 rotate-12" data-id="element-146" />
      <PawPrint className="pointer-events-none absolute top-24 right-2 w-20 h-20 text-teal-bright/10 -rotate-12" data-id="element-147" />
      <PawPrint className="pointer-events-none absolute bottom-32 -left-6 w-24 h-24 text-teal-bright/10 -rotate-6" data-id="element-148" />
      <PawPrint className="pointer-events-none absolute bottom-4 right-6 w-28 h-28 text-teal/20 rotate-6" data-id="element-149" />

      <div className="relative max-w-md mx-auto text-center space-y-3" data-id="element-150">
        <div className="inline-block bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full text-sm" data-id="element-151">
          🐾 Planillas Profesionales · Edición 2026
        </div>

        <h1 className="text-[32px] font-bold leading-tight" data-id="element-152">
          TU CLÍNICA VETERINARIA{' '}
          <span className="text-teal-bright" data-id="element-153">RESUELTA</span>
        </h1>

        <motion.div animate={{
        y: [0, -12, 0]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="py-2" data-id="element-154">
          <img src="https://cdn.magicpatterns.com/uploads/2F8XRs96rNmVHdT1pYqQ2W/Untitled_design.png" alt="Kit Veterinario Elite - planillas profesionales" className="w-full max-w-sm mx-auto rounded-lg drop-shadow-2xl" data-id="element-155" />
        </motion.div>

        <p className="text-[15px] leading-relaxed opacity-90" data-id="element-156">
          El kit completo de planillas profesionales para veterinarios que
          quieren gestionar su clínica como expertos.
        </p>

        <div className="space-y-2 pt-1" data-id="element-157">
          <button onClick={() => scrollToSection('precios')} className="w-full bg-teal text-white h-14 rounded-xl font-bold text-lg hover:bg-teal/90 transition-colors" data-id="element-158">
            🐾 Quiero el Kit Veterinario Elite
          </button>

          <button onClick={() => scrollToSection('planillas')} className="w-full border-2 border-white text-white h-14 rounded-xl font-semibold hover:bg-white/10 transition-colors" data-id="element-159">
            Ver qué incluye ↓
          </button>
        </div>

        <div className="text-sm opacity-80 pt-1 space-x-2" data-id="element-160">
          <span data-id="element-161">⭐ 4.9/5</span>
          <span data-id="element-162">·</span>
          <span data-id="element-163">+800 veterinarios</span>
          <span data-id="element-164">·</span>
          <span data-id="element-165">📦 +100 planillas</span>
          <span data-id="element-166">·</span>
          <span data-id="element-167">🔒 Garantía 7 días</span>
        </div>
      </div>
    </section>;
}